import * as angular from 'angular';
import BackButtonController from "./controllers/back-button.controller";
import StandardComponent from "components/standards/components/StandardComponent";

"use strict";

class BackButtonComponent extends StandardComponent {

    // This will enable the debug mode of this class
    public debug = false;
    public moduleFolder = 'components/back-button';

    /**
     * PLease make sure that each function contain correct
     * documentation.
     */
    public bindings = {
        scanStation: '<',
        data: '<',
        main: '=',
        management : '='
    }

    // This will set what will be the controller of this component
    public controller : any = BackButtonController;

    // This will set an alias
    public controllerAs: string = 'bb';
}

angular.module('BackButtonModule').component('backButton', <StandardComponent> new BackButtonComponent);